var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonSettings = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M37.459 29.457a3.006 3.006 0 00.6 3.31l.108.11c.34.336.608.739.79 1.179a3.616 3.616 0 010 2.783c-.184.44-.453.843-.79 1.18a3.63 3.63 0 01-3.963.789 3.668 3.668 0 01-1.18-.789l-.108-.108a3.009 3.009 0 00-3.31-.6 3.01 3.01 0 00-1.818 2.746v.307a3.636 3.636 0 01-7.271 0v-.162a3.008 3.008 0 00-.559-1.674c-.35-.49-.84-.862-1.406-1.072a3.004 3.004 0 00-3.31.6l-.109.109c-.336.339-.74.608-1.18.789a3.615 3.615 0 01-2.783 0 3.668 3.668 0 01-1.18-.789 3.593 3.593 0 01-.788-1.18 3.615 3.615 0 010-2.783c.183-.44.452-.843.788-1.18l.109-.108a3.005 3.005 0 00.6-3.31 3.01 3.01 0 00-2.746-1.818h-.308a3.642 3.642 0 01-2.571-1.065A3.617 3.617 0 014 24.147a3.632 3.632 0 013.636-3.636H7.8a3.008 3.008 0 001.674-.558c.49-.35.862-.84 1.071-1.405a3.005 3.005 0 00-.6-3.311l-.109-.108a3.592 3.592 0 01-.788-1.18 3.616 3.616 0 010-2.784c.183-.44.452-.842.788-1.18.337-.338.74-.607 1.18-.788a3.616 3.616 0 012.783 0c.44.184.843.452 1.18.789l.108.108a3.009 3.009 0 003.311.6h.146a3.004 3.004 0 001.818-2.746V7.64A3.642 3.642 0 0124.001 4a3.632 3.632 0 013.636 3.636V7.8a3.004 3.004 0 001.818 2.745 3.005 3.005 0 003.31-.6l.109-.109c.337-.339.74-.607 1.18-.788a3.615 3.615 0 012.783 0 3.628 3.628 0 012.246 3.36c0 .478-.094.951-.278 1.391-.183.44-.452.843-.788 1.18l-.109.108a3.008 3.008 0 00-.6 3.311v.146a3.01 3.01 0 002.746 1.818h.308A3.632 3.632 0 0143.998 24a3.636 3.636 0 01-3.636 3.636h-.163a3.003 3.003 0 00-1.643.499 3.052 3.052 0 00-1.097 1.323z", fill: fills.dark }),
        React.createElement("path", { d: "M24.001 30.227a6.226 6.226 0 100-12.452 6.226 6.226 0 000 12.452z", fill: fills.light })));
}, {
    name: identiconComponentName,
})({});
